import { render, staticRenderFns } from "./AgreenemtCheckboxses.vue?vue&type=template&id=5280cc85&scoped=true"
import script from "./AgreenemtCheckboxses.vue?vue&type=script&lang=js"
export * from "./AgreenemtCheckboxses.vue?vue&type=script&lang=js"
import style0 from "./AgreenemtCheckboxses.vue?vue&type=style&index=0&id=5280cc85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5280cc85",
  null
  
)

export default component.exports